import i18n from '@/i18n';
import { Notification, Message, MessageBox } from 'element-ui';

export default {
  namespaced: true,
  state: {
    disabledErrorPrefixes: [],
    disabledErrorHTTPCode: []
  },
  actions: {
    enableErrorCodePrefix({ commit }, prefix) {
      commit('ENABLE_ERROR_PREFIX', prefix);
    },
    disableErrorCodePrefix({ commit }, prefix) {
      commit('DISABLE_ERROR_PREFIX', prefix);
    },
    enableErrorHTTPCode({ commit }, prefix) {
      commit('ENABLE_HTTP_RESPONSE_PREFIX', prefix);
    },
    disableErrorHTTPCode({ commit }, prefix) {
      commit('DISABLE_HTTP_RESPONSE_PREFIX', prefix);
    },
    toast({ commit }, toast) {
      const { type, message } = toast;
      Message({
        message,
        type: type || 'error'
      });
    },
    success({ commit }, messageObj) {
      const { title, duration, message } = messageObj;

      return Notification({
        duration: duration || 2000,
        title: title || i18n.t('common.success'),
        message: message || '',
        type: 'success'
      });
    },
    error({ commit }, messageObj) {
      const { title, duration, message, dangerouslyUseHTMLString } = messageObj;

      return Notification({
        duration: duration || 4000,
        title: title || i18n.t('common.error'),
        message: message || '',
        dangerouslyUseHTMLString: !!dangerouslyUseHTMLString,
        type: 'error'
      });
    },
    confirm({ state }, { title, message, cancelButtonText, confirmButtonText, type, dangerouslyUseHTMLString }) {
      return MessageBox.confirm(message, title || i18n.t('common.warning'), {
        cancelButtonText: cancelButtonText || i18n.t('common.cancel'),
        confirmButtonText: confirmButtonText || i18n.t('common.confirm'),
        type: type || 'warning',
        dangerouslyUseHTMLString
      });
    },
    requestError({ state, dispatch }, err) {
      if (err.response) {
        const { data } = err.response;
        if (Array.isArray(data)) {
          // Display error from database if that exists
          data.forEach(e => {
            const errCode = e.code || e.Code;
            const errMessage = e.message || e.Message;
            if (!state.disabledErrorPrefixes.some(prefix => errCode && errCode.startsWith(prefix))) {
              dispatch('error', { message: errMessage || errCode });
            }
          });
        } else {
          if (!state.disabledErrorHTTPCode.some(code => err.response.status === code)) {
            dispatch('error', { message: i18n.t('error.general_request') });
          }
        }
      } else {
        dispatch('toast', { message: err.message });
      }
    },
    formValidationFailed({ dispatch }) {
      dispatch('toast', { message: i18n.t('validation.formValidationFailed') });
    },
    dataUpdated({ dispatch }) {
      dispatch('success', { message: i18n.t('common.data_updated') });
    },
    dataSaveError({ dispatch }) {
      dispatch('error', { message: i18n.t('common.data_save_error') });
    },
    deleteCompleted({ dispatch }) {
      dispatch('success', { message: i18n.t('common.delete_completed') });
    },
    deleteCancelled({ dispatch }) {
      dispatch('toast', { message: i18n.t('common.delete_cancelled') });
    },
    deleteConfirm({ dispatch }, summary) {
      if (summary) {
        return dispatch('confirm', {
          message: i18n.t('common.delete_record_summary_warning', { summary }),
          confirmButtonText: i18n.t('common.delete'),
          dangerouslyUseHTMLString: true
        });
      } else {
        return dispatch('confirm', {
          message: i18n.t('common.delete_record_warning'),
          confirmButtonText: i18n.t('common.delete')
        });
      }
    },
    closeUnsavedConfirm({ dispatch }) {
      return dispatch('confirm', {
        title: i18n.t('common.warning'),
        message: i18n.t('common.close_unsaved_warning'),
        cancelButtonText: i18n.t('common.stay'),
        confirmButtonText: i18n.t('common.close')
      });
    }
  },
  getters: {},
  mutations: {
    ENABLE_ERROR_PREFIX: (state, prefix) => {
      const index = state.disabledErrorPrefixes.indexOf(prefix);
      if (index > -1) {
        state.disabledErrorPrefixes.splice(index, 1);
      }
    },
    DISABLE_ERROR_PREFIX: (state, prefix) => {
      const index = state.disabledErrorPrefixes.indexOf(prefix);
      if (index < 0) {
        state.disabledErrorPrefixes.push(prefix);
      }
    },
    ENABLE_HTTP_RESPONSE_PREFIX: (state, code) => {
      const index = state.disabledErrorHTTPCode.indexOf(code);
      if (index > -1) {
        state.disabledErrorHTTPCode.splice(index, 1);
      }
    },
    DISABLE_HTTP_RESPONSE_PREFIX: (state, code) => {
      const index = state.disabledErrorHTTPCode.indexOf(code);
      if (index < 0) {
        state.disabledErrorHTTPCode.push(code);
      }
    }
  }
};
